import { render, staticRenderFns } from "./qqlist.vue?vue&type=template&id=2ad0c4cc&"
import script from "./qqlist.vue?vue&type=script&lang=js&"
export * from "./qqlist.vue?vue&type=script&lang=js&"
import style0 from "./qqlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports